import { render, staticRenderFns } from "./roleAdmin.vue?vue&type=template&id=2c57ef24"
import script from "./roleAdmin.vue?vue&type=script&lang=js"
export * from "./roleAdmin.vue?vue&type=script&lang=js"
import style0 from "./roleAdmin.vue?vue&type=style&index=0&id=2c57ef24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports